/**
 * Words people add to a request that never say what it's about or who it's for:
 * "help me create a notice about quickly" has no topic, and "can you create a
 * notice for me?" names no one. One list, so every task reads them the same way.
 */
const FILLER_WORDS = [
  "real quick",
  "really quickly",
  "quickly",
  "quick",
  "asap",
  "as soon as possible",
  "right now",
  "right away",
  "now",
  "please",
  "pls",
  "thanks",
  "thx",
  "cheers",
  "ta",
  "thank you",
  "if you can",
  "if possible",
];

/** The person asking, never who something is for: "for me" is filler too. */
const ASKER_WORDS = ["me", "us", "myself", "ourselves"];

const pattern = (words: string[]) => words.map((w) => w.replace(/\s+/g, "\\s+")).join("|");
const phrases = pattern([...FILLER_WORDS, ...ASKER_WORDS.map((w) => `for ${w}`)]);
const AT_END = new RegExp(`[\\s,]*\\b(?:${phrases})$`, "i");
const ASKER = new RegExp(`^(?:${pattern(ASKER_WORDS)})$`, "i");
/**
 * "for me" and "for us" ending a phrase: they say who's asking, so the real "to Grade 2"
 * is found. "for us parents" names who it's for, so it stays.
 */
export const FOR_THE_ASKER = new RegExp(
  `\\s*\\bfor\\s+(?:${pattern(ASKER_WORDS)})(?=\\s*(?:$|[,.?!]|\\b(?:to|about|on|by|at|please)\\b))`,
  "gi"
);

/**
 * The text without filler words at the end: "the swimming gala asap" is "the swimming gala".
 * Only the end, as a title can start with one ("Quick Cricket", "Thanks for the donations").
 */
export function trimFiller(text: string): string {
  let trimmed = text.trim();
  for (let before = ""; before !== trimmed; ) {
    before = trimmed;
    trimmed = trimmed.replace(AT_END, "").trim();
  }
  return trimmed;
}

/** Nothing but filler words, or the person asking ("me"): never a topic or a recipient. */
export const isFiller = (text: string) => {
  const trimmed = trimFiller(text);
  return !trimmed || ASKER.test(trimmed);
};
